module.exports = __webpack_public_path__ + "img/card-bg-2.43962adb.jpg";